export default "__VITE_ASSET__sIydm5$p__"